<template>
  <v-container class="gray-wrapper" fluid>
    <div style="max-width:25rem;margin:0 auto;" class="config-title">
      <router-link to="/config" class="back-icon">
        <v-btn icon large>
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">
        <!-- {{ $t('recommend.myPerformance') }} -->
        추천목록
      </div>
    </div>

    <div class="panels-container">
      <v-expansion-panels flat :value="0">
        <v-expansion-panel
          v-for="num in 1"
          :key="'expansion' + num"
          class="shadow-10-20"
        >
          <v-expansion-panel-header
            expand-icon="mdi-menu-down"
            class="font-weight-bold"
          >
            <div
              style="flex:none !important;display: flex;align-items: center;"
            >
              <div>Total
                <!-- {{ $t('recommend.genPromote' + num) }} -->
              </div>
              <div class="font-40 ml-1">
                ({{
                  (num === 1 ? depth1.length : depth2.length) +
                    $t('recommend.people')
                }})
              </div>
            </div>
            <!-- <div class="point-wrapper">
              <img
                style="width:1rem;margin-right:0.2rem;"
                src="@/assets/icon/point.svg"
              />
              {{ num === 1 ? 62.5 : 37.5 }}P {{ $t('recommend.paid') }}
            </div> -->
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-card flat>
              <v-card-text
                style="height: calc(var(--vh, 1vh) * 100 - 23.5rem);overflow: auto;padding:0 1.3rem 1rem;"
              >
                <template
                  v-if="(num === 1 ? depth1.length : depth2.length) === 0"
                >
                  <div class="item-wrapper justify-center">
                    {{ $t('recommend.noReferrals') }}
                  </div>
                </template>
                <template v-for="(item, idx) in num === 1 ? depth1 : depth2">
                  <div :key="'depth1' + idx">
                    <div class="item-wrapper">
                      <div class="date-wrapper">
                        <label>가입일 : {{ $moment(item.created_at).format('YYYY-MM-DD') }}</label> </br>
                        <label>직급 :   {{ item.grade == 1? '스텝':'관리자'  }} </label> </br>
                        <label>핸드폰 : {{ item.phone }}</label> </br>
                        <label>닉네임 : {{ item.name }}</label>
                        

                        <!-- {{ $t('recommend.join') }}                         -->
                      </div>

                      <div class="date-wrapper" style="float:right" v-show="btnShow()" >

                          <v-btn                            
                            class="font-weight-bold mb-4" 
                            :color="btnColor(item.is_bill)"
                            block
                            x-large                 
                            :data-id=item.id
                            @click="changeBill(item.id)" 
                          >
<!-- primary -->
            
                          <!-- @click="changeBill()"                                    -->
                          <!-- @click="changeBill(item.id)"                                         -->

                          <!-- :disabled="isLoading" -->         
                            <span v-if="item.is_bill == 0">대 기</span>
                            <span v-else >완 료</span>

                          </v-btn>
                        </div>

                      <!-- <template v-if="item.name">
                        <div class="mail-wrapper error--text">
                          <v-icon color="error" small class="mr-1">
                            mdi-alert-circle-outline
                          </v-icon>
                          {{ item.name }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="mail-wrapper">
                          <div class="mail-inner">{{ item.name }}</div>
                        </div>
                      </template>
                       -->
                    </div>
                    <v-divider
                      v-if="
                        idx < (num === 1 ? depth1.length : depth2.length) - 1
                      "
                    ></v-divider>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      depth1: [],
      depth2: [] , 
      recommend : [] 
    }
  },
  methods: {
    btnShow(){
      //console.log( this.$store.state.user )
      return ( this.$store.state.user.is_admin > 0 || ( this.$store.state.user.is_bill > 0 && this.$store.state.user.grade > 1 ) ) ? true : false  ; 

    },
    btnColor( is_bill ) {
      return ( is_bill > 0 ) ? 'primary' : 'error'  ;
    } , 
    changeBill( staff_id ){
      // alert( staff_id  )
      // alert( event.target.getAttribute('data-id')  )  ;
 
    this.$store.commit('loading', true)
    this.$store
      .dispatch('STAFF_ACT' , {
        proc : 'staff_agree' , 
        staff_id: staff_id 
      })
      .then((res) => {
         // console.log(res.data.status) 

         if( res.data.status == true  )   {
          alert( "변경되었습니다. " ) ;
         }else{
          alert( "잠시후 다시 시도해 주세요 " ) ;
         } ; 
         location.reload() ;  
         this.$store.commit('loading', false)

      })
      .catch((err) => {
        // console.log(err)
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('errorServer'),
          timeout: 2000
        })

      })
    
   
  
  

    }
  } , 
  computed: {
    // user() {
    //   return this.$store.getters.user
    // }
  },
  created() {
    this.$store.commit('loading', true)
    this.$store
      .dispatch('STAFF_ACT' , {
        proc : 'recommend'
      })
      .then((res) => {
         console.log(res)
         const result = res.data.result
         if( result == true ) {
          this.depth1 = res.data.recommend ; 
          this.recommend = res.data.recommend
         }else { 
          this.depth1 =[]; 
          this.recommend = [] ; 
         }
         // this.depth1 = result.depth1.list
         // this.depth2 = result.depth2.list
      })
      .catch((err) => {
        // console.log(err)
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('errorServer'),
          timeout: 2000
        })
      })
    this.$store.commit('loading', false)
  }
}
</script>

<style scoped>
.point-wrapper {
  position: absolute;
  right: 23px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
}
.item-wrapper {
  width: 100%;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.85rem;
  min-height: 3rem;
}
.date-wrapper {
  min-width: 6.5rem;
  margin-right: 0.5rem;
  color: #b1b1b1;
  font-weight: 500;
}
.mail-wrapper {
  /* display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end; */
  width: calc(100% - 7rem);
  text-align: end;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}
.mail-inner {
  width: 100%;
  text-align: end;
}
</style>
